export default __webpack_public_path__ + "static/media/circle3.2.00ee93a0.svg";